import React from "react";
import InvoiceComponent from "./InvoiceComponent";

const Invoice = ({ closeInvoice, data }) => {
  return (
    <div className="cu-visit-pre-cont fixed top-0 left-0 w-full h-[100dvh] bg-white z-50">
      <InvoiceComponent closeInvoice={closeInvoice} data={data} />
    </div>
  );
};

export default Invoice;
